import React from 'react'
import Board from './Board'

export default () => (
  <div className='container'>
    <Board />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Game.js